import { Formik } from "formik";
import {
  Button,
  Chip,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";
import CustomField from "../shared/CustomTextField";
import { useStore } from "../../hooks/store";
import Styles from "./Form.module.css";
import { createElement, useEffect, useState } from "react";
import {
  postNews,
  postNewsTheme,
  updateNews,
  updateNewsTheme,
} from "../../utils/API/newsMethods";
import VideoUploader from "../VideoUploader";
import ColorPicker from "material-ui-color-picker";
import * as Icons from "@mui/icons-material";
import { newsCategories } from "../../utils/categoryList";
// import { endpoints, uploaderType } from "../../utils/config";

export default function NewsThemeForm() {
  const store = useStore();
  const newsThemeData = store.form.dataToUpdate;
  const [initValues, setValues] = useState(
    newsThemeData || {
      id: null,
      name: null,
      main_color: "#1976d2",
      text_color: "#000",
      icon_name: null,
    }
  );
  const [mainColor, setMainColor] = useState(initValues.main_color);
  const [textColor, setTextColor] = useState(initValues.text_color);
  const pickerWrapperStyles = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  };

  const pickerDisplayStyles = {
    height: "50px",
    width: "auto",
    aspectRatio: "1/1",
    borderRadius: "0.3rem",
    border: "0.5px solid black",
  };
  const submitNews = (values) => {
    postNewsTheme(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const submitUpdatedNews = (values) => {
    updateNewsTheme(values.id, values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = newsThemeData && { flexDirection: "row" };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (newsThemeData) {
          submitUpdatedNews(values);
        } else {
          submitNews(values);
        }

        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        setFieldValue,
      }) => (
        <>
          <p>{newsThemeData ? "Изменение категории" : "Создание категории"}</p>

          <form onSubmit={handleSubmit}>
            <div
              className={Styles.form_content}
              style={{ flexDirection: "row" }}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="name"
                  label="Название категории"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <CustomField
                  name="icon_name"
                  label="Иконка категории"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.icon_name}
                  select>
                  {newsCategories.map((cat) => (
                    <MenuItem key={cat.id} value={cat.id}>
                      <ListItemIcon>
                        <cat.icon />
                      </ListItemIcon>
                      <ListItemText primary={cat.label} />
                    </MenuItem>
                  ))}
                </CustomField>
                <div style={pickerWrapperStyles}>
                  <ColorPicker
                    variant={"outlined"}
                    id="main_color"
                    fullWidth
                    name="main_color"
                    className="colorPicker"
                    defaultValue={mainColor}
                    // floatingLabelText="Цвет фона"
                    onBlur={handleBlur}
                    style={{ color: "#000 !important" }}
                    onChange={(e) => {
                      // values.main_color = e;

                      if (!e) {
                        setMainColor(mainColor);
                        document.getElementById("main_color").value = mainColor;
                        values.main_color = mainColor;

                        return;
                      }
                      values.main_color = e;
                      document.getElementById("main_color").value = e;

                      setMainColor(e);
                    }}
                  />
                  <div
                    style={{
                      ...pickerDisplayStyles,
                      backgroundColor: mainColor,
                    }}
                  />
                </div>
                <div style={pickerWrapperStyles}>
                  <ColorPicker
                    fullWidth
                    variant={"outlined"}
                    id="text_color"
                    name="text_color"
                    className="colorPicker"
                    value={textColor}
                    defaultValue={textColor}
                    onBlur={handleBlur}
                    style={{ color: "#000 !important" }}
                    onChange={(e) => {
                      if (!e) {
                        setTextColor(textColor);
                        document.getElementById("text_color").value = textColor;
                        values.text_color = textColor;
                        return;
                      }
                      setTextColor(e);
                      values.text_color = e;
                      document.getElementById("text_color").value = e;
                    }}
                  />
                  <div
                    style={{
                      ...pickerDisplayStyles,
                      backgroundColor: textColor,
                    }}
                  />
                </div>
              </div>
              <div className={Styles.form_fields}>
                <p style={{ margin: "0 auto" }}>Предпросмотр</p>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                  <Chip
                    sx={{
                      transform: "scale(2)",
                      backgroundColor: mainColor,
                      color: textColor,
                      borderRadius: "8px",
                    }}
                    label={values.name}
                    icon={
                      Icons[values.icon_name]
                        ? createElement(Icons[values.icon_name])
                        : null
                    }
                  />
                </div>
              </div>
            </div>
            <div className="form_actions">
              <Button onClick={handleReset}>Очистить</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
